import { memo } from 'react';

import { Heading, Text } from '@/components/core';
import { ExportHeader, SetupRequired } from '@/components/flow';
import { N8NLogo } from '@/components/logos';
import { toActionId, useGetAction } from '@/hooks/api';
import { isNotConfiguredExport } from '@/utils';

export type N8NExportNodeContentProps = {
  agentId: string;
  actionId: string;
};

const IN8NExportNodeContent = ({ agentId, actionId }: N8NExportNodeContentProps) => {
  const { data: action } = useGetAction(toActionId(actionId));

  return (
    <>
      <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
        <ExportHeader agentId={agentId} actionId={actionId}>
          <N8NLogo size="lg" />
          <Heading size="lg">Export to N8N</Heading>
        </ExportHeader>
      </div>

      <div className="flex gap-2 pt-2">
        {isNotConfiguredExport(action) ? (
          <SetupRequired />
        ) : (
          <Text className="flex flex-row flex-wrap items-center gap-2">
            Export files to:
            <Text className="flex items-center gap-1 rounded-lg bg-gray-100 px-2 py-1">N8N</Text>
          </Text>
        )}
      </div>
    </>
  );
};

export const N8NExportNodeContent = memo(IN8NExportNodeContent) as typeof IN8NExportNodeContent;
